import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BaseComponent,
  ListComponent,
  RouterService,
  SearchResult,
  hideString,
} from 'src/app/shared';
import { Http } from 'src/app/shared/services/http.service';
import { UserActionService } from '../../../shared';
import { UserActions } from '../../../shared/models/user';
import { ActivityService } from '../../services/activity.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Session } from '../../services/session.service';
import { UserRoleService } from '../../services/user-role.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-benefits',
    template: `
    <h3 class="app-header-3">{{ 'Work status' | translation:translationRequest }}</h3>
    <app-loading-panel [state]="isLoaded ? 'Loaded' : 'Loading'">
      <ng-template #content>
        <app-list
          #table
          [dataSource]="workstatusinfo"
          [template]="row1"
          class="app-pt2"
          [filterEnabled]="false"
          loadingMessage=""
          noDataIcon="work_outline"
          noDataMessage="No work status details available"
          [loaded]="isLoaded"
          *ngIf="showWorkStatus"
          [tableAriaLabel]="'Work Status'"
        >
          <ng-container header>
            <tr class="tw-flex tw-flex-wrap tw-w-full">
              <app-list-header
                name="workstatus"
                label="Work Status"
                class="tw-w-full md:tw-w-[40%]"
                [names]="['worsStatus']"
              ></app-list-header>

              <app-list-header
                name="effectiveDate"
                label="AS OF"
                class="tw-w-full md:tw-w-[15%]"
                [names]="['effectiveDate']"
              ></app-list-header>

              <app-list-header
                name="benefitBegin"
                label="Benefits Begin"
                class="tw-w-full md:tw-w-[15%]"
                [names]="['benefitBegin']"
              ></app-list-header>

              <app-list-header
                name="benefitEnd"
                label="Benefits End"
                class="tw-w-full md:tw-w-[15%]"
                [names]="['benefitEnd']"
              ></app-list-header>

              <!-- <app-list-header
              name="type"
                label="Type"
              class="tw-w-full md:tw-w-[15%]"
            ></app-list-header>-->

              <app-list-header
                name="benefitStatus"
                label="Benefit status"
                class="tw-w-full md:tw-w-[15%]"
                 [names]="['benefitStatus']"
              ></app-list-header>
            </tr>
          </ng-container>
        </app-list>
      </ng-template>
    </app-loading-panel>

    <ng-template #row1 let-element>
      <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
        <td class="tw-w-full md:tw-w-[40%]">
          <app-value
            label="Work Status"
            [value]="element.workstatus"
            layout="row-xs"
            [tabindex]="0"
          >
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[15%]">
          <app-value
            label="AS OF"
            [value]="element.effectiveDate  !== null ? (element.effectiveDate | format : 'date') : null"
            layout="row-xs"
            [tabindex]="0"
            [translationNeeded]="false"
          >
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[15%]">
          <app-value
            label="Benefits Begin"
            [value]="
              element.benefitBegin !== null
                ? (element.benefitBegin | format : 'date')
                : null
            "
            layout="row-xs"
            [tabindex]="0"
            [translationNeeded]="false"
          >
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[15%]">
          <app-value
            label="Benefits End"
            [value]="
              element.benefitEnd !== null
                ? (element.benefitEnd | format : 'date')
                : null
            "
            layout="row-xs"
            [tabindex]="0"
            [translationNeeded]="false"
          >
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[15%]">
          <app-value
            label="Benefit status"
            [value]="element.benefitStatus"
            layout="row-xs"
            [tabindex]="0"
          >
          </app-value>
        </td>
      </tr>
    </ng-template>

    <br />
    <div *ngIf="hideDiv">
      <h3 class="app-header-3">{{ 'Benefit plan' | translation:translationRequest}}</h3>
      <app-loading-panel [state]="benefitsLoaded ? 'Loaded' : 'Loading'">
        <ng-template #content>
          <div>
            <span *ngIf="this.userRole.manager">
              <span class="H1header">{{ 'BENEFIT PLAN :' | translation:translationRequest}}</span>
            </span>
            <span *ngIf="this.userRole.manager"> {{ benefitPlanName | translation:translationRequest }}</span>
            <br />
            <span *ngIf="showMaxBenefitDurationDate"
              ><span class="H1header"
                >{{ 'MAXIMUM BENEFIT DURATION DATE :' | translation:translationRequest}}</span
              ></span
            ><span *ngIf="showMaxBenefitDurationDate">
              {{ maxBenifitDuration | format : 'date' }}</span
            >
            <br />
          </div>

          <app-list
            #benefitsLayout
            [dataSource]="benefitDetails"
            [template]="row"
            class="app-pt2"
            [filterEnabled]="false"
            loadingMessage=""
            [loaded]="isLoaded"
            [paginatorEnabled]="false"
            *ngIf="showBenefitDetails"
            [tableAriaLabel]="'Benefits'"
          >
            <ng-container header>
              <tr class="tw-flex tw-flex-wrap tw-w-full">
                <app-list-header
                  name="fromDate"
                  label="Begin Date"
                  class="tw-w-full md:tw-w-[30%]"
                  [names]="['fromDate']"
                ></app-list-header>

                <app-list-header
                  name="thruDate"
                  label="End Date"
                  class="tw-w-full md:tw-w-[30%]"
                  [names]="['thruDate']"
                ></app-list-header>

                <app-list-header
                  name="frequency"
                  label="Benefit Frequency"
                  class="tw-w-full md:tw-w-[15%]"
                ></app-list-header>

                <app-list-header
                  name="rate"
                  label="Benefit Rate"
                  class="tw-w-full md:tw-w-[20%]"
                  *ngIf="showBenefitRate"
                ></app-list-header>
              </tr>
            </ng-container>
          </app-list>
          <ng-template #row let-element>
            <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
              <td class="tw-w-full md:tw-w-[30%]">
                <app-value
                  label="Begin Date"
                  [value]="element.fromDate | format : 'date'"
                  layout="row-xs"
                  [tabindex]="0"
                  [translationNeeded]="false"
                >
                </app-value>
              </td>
              <td class="tw-w-full md:tw-w-[30%]">
                <app-value
                  label="End Date"
                  [value]="element.thruDate | format : 'date'"
                  layout="row-xs"
                  [tabindex]="0"
                  [translationNeeded]="false"
                >
                </app-value>
              </td>
              <td class="tw-w-full md:tw-w-[15%]">
                <app-value
                  label="Benefit Frequency"
                  [value]="element.frequency"
                  layout="row-xs"
                  [tabindex]="0"
                >
                </app-value>
              </td>
              <td class="tw-w-full md:tw-w-[20%]">
                <app-value
                  label="Benefit Rate"
                  [value]="
                    !showMaskedRate ? (element.rate | currency) : element.rate
                  "
                  layout="row-xs"
                  *ngIf="showBenefitRate"
                  [tabindex]="0"
                  [translationNeeded]="false"
                >
                </app-value>
              </td>
            </tr>
          </ng-template>
        </ng-template>
      </app-loading-panel>
    </div>
    <br />
    <br />
  `,
    styles: [
        `
      .NotBoldH3header {
        font-size: 24px;
      }
      .H3header {
        font-size: 24px;
        font-weight: bold;
      }
      .H3headerBenefitsPlan {
        font-size: 24px;
      }
      .H1header {
        font-size: 11px;
        font-weight: 700;
        line-height: 16px;
        color: #171c20;
      }
    `,
    ],
    standalone: false
})
export class BenefitsComponent extends BaseComponent implements OnInit {
  @ViewChild('benefitsLayout') benefitsLayout: ListComponent;
  claimId: any;
  @Input()
  claim: SearchResult;
  source: any;
  isLoaded: boolean = false;
  benefitsLoaded: boolean = false;
  maxBenifitDuration: any;
  workstatusinfo: WorkStatus[];
  data: any;
  benefitDetails: BenefitTable[];
  userLOB: any;
  workstatusdetails: WorkStatus[];
  isToggle: boolean = false;
  hasBenefits: boolean = false;
  hideDiv: boolean;
  isEmployee: boolean = this.userRole.employee;
  mgrAction: UserActions | null;
  showWorkStatus: boolean = false;
  showBenefitDetails: boolean = false;
  lob: string;
  showBenefitRate: boolean = true;
  showMaxBenefitDurationDate: boolean = true;
  showMaskedRate: boolean = false;
  benefitPlanName: string;
  @Input() translationRequest:TranslationRequest

  constructor(
    private route: ActivatedRoute,
    private activityService: ActivityService,
    public routerService: RouterService,
    public session: Session,
    private http: Http,
    public userRole: UserRoleService,
    public claimConfigService: ConfigurationService,
    private userAction: UserActionService
  ) {
    super();
    if (this.userRole.manager) {
      this.mgrAction = this.userAction.getAction();
    }
    this.hasBenefits =
      this.claimConfigService.getFeatureAccess('Benefits') &&
      (this.userRole.employee ||
        (this.userRole.manager && this.mgrAction == UserActions.ViewOwnClaim) ||
        this.mgrAction == UserActions.MgrViewEmpClaim);
    this.showWorkStatus =
      this.isEmployee ||
      (this.userRole.manager && this.mgrAction == UserActions.ViewOwnClaim) ||
      (this.userRole.manager && this.mgrAction == UserActions.MgrViewEmpClaim);
  }

  async ngOnInit() {
    this.subs.sink = this.route.queryParams.subscribe(() =>
      this.loadClaimFromUrl()
    );
    this.lob = this.claim.lob;
    if (this.hasBenefits) {
      await this.getBenefitPlan();
      this.benefitsLoaded = true;
    }
    this.getWorkStatusInfo();
  }
  private async loadClaimFromUrl() {
    this.claimId = this.route.snapshot.queryParamMap.get('claimId');
  }

  async getBenefitPlan() {
    const data = await this.http.get<any>(
      `/api/claim/${this.claimId}/${this.lob}/${this.claim.source}/GetBenefits`
    );
    if (data != null || data != undefined) {
      this.benefitDetails = data.benefitSchedules;
      this.benefitPlanName = data.benefitPlan?.description;
      this.benefitDetails.forEach((element) => {
        if (
          this.session.user.emulatorContext &&
          this.session.user.emulatorContext.isEmulating
        ) {
           if(element.rate) {
              element.rate = hideString(element.rate.toString(), '*');
           }
          this.showMaskedRate = true;
        }

        if (
          element.rate == null
          /*||
          (this.session.user.emulatorContext &&
            this.session.user.emulatorContext.isEmulating)*/
        ) {
          this.showBenefitRate = false;
        }
      });
      this.maxBenifitDuration = data.maximumBenefitDurationDate;
      if (this.maxBenifitDuration == '') {
        this.showMaxBenefitDurationDate = false;
      }
    }
    this.hideDiv =
      this.benefitDetails && this.benefitDetails.length > 0 ? true : false;
    this.showBenefitDetails =
      this.isEmployee ||
      (this.benefitDetails != null &&
        this.userRole.manager &&
        this.mgrAction == UserActions.ViewOwnClaim) ||
      this.mgrAction == UserActions.MgrViewEmpClaim;
  }

  async getWorkStatusInfo() {
    const data = await this.activityService.getWorkStatusInfo(
      this.claim.source,
      this.claimId,
      this.claim.lob
    );
    if (
      data != null ||
      (data != undefined && this.isEmployee) ||
      (data != undefined &&
        this.userRole.manager &&
        (this.mgrAction == UserActions.ViewOwnClaim ||
          this.mgrAction == UserActions.MgrViewEmpClaim))
    ) {
      this.workstatusdetails = data;
      this.workstatusdetails.forEach((element) => {
        if (element.workstatus === 'AT WORK') {
          element.benefitBegin = null;
          element.benefitEnd = null;
          element.benefitStatus = '';
        }
      });
      
      this.filterData();
      this.isLoaded = true;
    }
    this.benefitsLayout?.setSort('fromDate', 'desc');
  }

  filterData() {
    const result: WorkStatus[] = [];
    if (this.workstatusdetails != null && this.workstatusdetails != undefined) {
      this.workstatusdetails.forEach((x) => result.push(x));
      this.isLoaded = true;
      this.workstatusdetails.forEach((element) => {
        if (
          element.benefitEnd != null &&
          element.benefitEnd.toString() > Date()
        ) {
          const data = this.workstatusdetails.reduce((a, b) =>
            a.benefitBegin > b.benefitBegin ? a : b
          );
          result.push(data);
        }
      });
      this.workstatusinfo = result;
    }
  }
}

class WorkStatus {
  workstatus?: string;
  duration?: string;
  benefitBegin?: Date;
  benefitEnd?: Date;
  type?: string;
  benefitStatus?: string;
  workStatusNumber?: number;
  effectiveDate?: Date;
}

class BenefitTable {
  BenefitFreq: string;
  rate: string;
  BenfitBeginDate: Date;
  BenefitEndDate: Date;
  BenefitDuration: Date;
}
